/**
 * App-wide limits for recipes, grocery lists, and grocery list items.
 * Enforced in hooks and reflected in UI messaging.
 */
export const MAX_RECIPES_PER_USER = 50;
export const MAX_GROCERY_ITEMS_PER_LIST = 200;
export const MAX_GROCERY_LISTS_PER_HOUSEHOLD = 5;
